// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const RatingBarsConatiner = styled.div`
  width: 100%;

  .star {
    height: 24px;
    padding-left: 0 6px 0 5px;
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: ${BREAKPOINTS.TABLET}px) {
    justify-content: start;
  }
`;

export const RatingRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .star {
    padding: ${({ theme }) =>
      `${theme.spacing.spacing10} ${theme.spacing.spacing20} ${theme.spacing.spacing20} ${theme.spacing.spacing20}`};
    align-items: baseline;
  }
  @media screen and (min-width: ${BREAKPOINTS.TABLET}px) {
    justify-content: start;
  }
`;

export const RatingTextLeft = styled.span`
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textSecondary};
  text-align: center;
  width: 20px;
`;

export const RatingTextRight = styled.span`
  ${({ theme }) => theme.typography.bodyMedium};
  width: 36px;
  color: ${({ theme }) => theme.colors.textSecondary};
  position: relative;
`;
